/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { useRef, useState, useEffect, useContext, Fragment } from 'react';
import {
  NavBar,
  Icon,
  Tabs,
  ListView,
  ActivityIndicator,
  PullToRefresh,
  Button,
  Toast,
} from 'antd-mobile';
import { useHistory } from 'react-router';
import { getBooleanValue, getApp } from '@/utils';
import DrawerWrapper from '@/components/drawerWrapper';
import SearchWrapper from '@/components/searchWrapper';
import Filter from '@/components/filter';
import { Resource } from '@/components/studio/list';
import { ResItem } from '@/components/studio/item';
import { LiveChannelItem } from '@/busi/saas/prestigiousSchool';
import { list as getLiveChannel } from '@/services/saas/liveChannel';
import { MyContext } from '@/utils/contextManager';
import { getIdByCode, getAttrsByTmpId, getAttrList } from '@/services/saas/appAttr';
import { getUserTeachingInfoPage } from '@/services/saas/statistics';
import { detail } from '@/services/saas/schoolFamous';
import { dropDown } from '@/services/saas/dictbiz';
import { list as getResList } from '@/services/saas/res';
import bg_school from '@/images/bg_school.png';

const tabs = [
  { title: '名师直播间', key: 'liveRoom' },
  { title: '任课老师', key: 'teacher' },
  { title: '名校资源', key: 'res' },
];

const getAttrs = async (data) => {
  const filterList = {};
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    if (item.attr.dataType === 'list') {
      filterList[item.detailId] = {
        child: item.child.detailId,
        label: item.attributeDisplayname,
        list: [],
      };
      if (!item.attr.pattributeId) {
        const resp = await getAttrList({
          attributeTemplateDetailId: item.detailId,
        });
        if (resp && resp.success) {
          filterList[item.detailId].list = resp.data.map((item) => ({
            name: item.text,
            value: item.value,
          }));
        }
      }
    }
  }
  return filterList;
};

const getDefaultData = async (appCode, tableCode = 'ts_conference') => {
  const respAttrTemp = await getIdByCode({
    appCode,
    tableCode,
  });
  if (respAttrTemp.success) {
    const respAttrs = await getAttrsByTmpId({
      templateId: respAttrTemp.data,
    });
    if (respAttrs.success) {
      const filterList = await getAttrs(respAttrs.data);
      return filterList;
    }
  }
};

const SubjectFilter = ({ onSearch = () => {} }) => {
  const { setDrawer } = useContext(MyContext);
  const [subjectList, setSubjectList] = useState([]);
  const [subject, setSubject] = useState('');

  const getSubjectList = async () => {
    const response = await dropDown({ code: 'subject' });
    if (response.success) {
      setSubjectList([{ text: '全部', value: '' }].concat(response.data));
    }
  };

  useEffect(() => {
    getSubjectList();
  }, []);

  return (
    <div className="subject-filter">
      <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => setDrawer()}>
        <span>选择学科</span>
      </NavBar>
      <div className="filter-list">
        <p className="filter-title">学科</p>
        <div className="list-wrap">
          {subjectList.map((item) => (
            <Button
              key={item.value}
              inline
              type={item.value === subject ? 'primary' : 'default'}
              onClick={() => {
                setSubject(item.value);
              }}
            >
              {item.text}
            </Button>
          ))}
        </div>
      </div>
      <div className="filter-button">
        <Button
          type="primary"
          onClick={() => {
            onSearch(subject);
            setDrawer();
          }}
          style={{ marginBottom: 10 }}
        >
          确定
        </Button>
        <Button
          onClick={() => {
            setSubject('');
            setDrawer();
            onSearch('');
          }}
        >
          重置
        </Button>
      </div>
    </div>
  );
};

const ListWrap = (props) => {
  return <ul>{props.children}</ul>;
};

const pullToRefreshText = {
  activate: <span>开始刷新</span>,
  deactivate: <span>已取消</span>,
  release: <span>正在刷新</span>,
  finish: <span>已完成</span>,
};

const LiveRoom = ({ keyword, deptId, filter }) => {
  const [liveRoom, setLiveRoom] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 8,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { pagination, list, loading, hasMore } = liveRoom;
  const { current, size } = pagination;
  const [draging, setDraging] = useState(false);
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const listRef = useRef();
  const history = useHistory();

  const onEndReached = () => {
    if (!loading && hasMore) {
      getLiveRoom(current);
    }
  };

  const getLiveRoom = async (page) => {
    const { appId } = getApp() || {};
    let state = { loading: true, hasMore: true };
    if (page === 1) {
      state.list = [];
      setDataSource(dataSource.cloneWithRows([]));
    }
    setLiveRoom((famousSchool) => ({ ...famousSchool, ...state }));
    const response = await getLiveChannel({
      size,
      current: page,
      isPublish: 1,
      activityName: keyword,
      deptId,
      sourceModule: 'personal',
      sourceApp: appId,
      attrQuery: filter,
    });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const dataList = current === 1 ? records : [...list, ...records];
      setTimeout(() => {
        setLiveRoom({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list: dataList,
          loading: false,
          hasMore,
        });
        setDataSource(dataSource.cloneWithRows(dataList));
        setDraging(false);
      }, 400);
    }
  };

  useEffect(() => {
    getLiveRoom(1);
  }, [keyword, filter]);

  const row = (rowData, sectionID, rowID) => {
    const {
      coverUrl,
      activityName,
      liveChannelAttributeList,
      liveStatus,
      id,
    } = rowData;
    const subject = liveChannelAttributeList[2]
      ? liveChannelAttributeList[2].attributeValueName
      : '无';
    const isLive = liveStatus === '1';
    return (
      <Fragment key={rowID}>
        <LiveChannelItem
          coverUrl={coverUrl}
          title={activityName}
          subject={subject}
          isLive={isLive}
          onClick={() => {
            if (isLive) {
              history.push(`/apps/livePlay/liveChannel/${id}`);
            } else {
              Toast.info('直播尚未开始');
            }
          }}
        />
      </Fragment>
    );
  };

  return (
    <div className="teacher-live-room">
      <ListView
        ref={listRef}
        dataSource={dataSource}
        renderFooter={() => (
          <div style={{ textAlign: 'center' }}>
            {hasMore ? (
              loading ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <ActivityIndicator animating={true} text="加载中..." />
                </div>
              ) : (
                '加载完成'
              )
            ) : (
              '没有更多'
            )}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="active-list-wrap"
        pageSize={size}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            indicator={pullToRefreshText}
            onRefresh={() => {
              setDraging(true);
              getLiveRoom(1);
            }}
          />
        }
      />
    </div>
  );
};

const SchooolTeacher = ({ keyword, deptId, subject }) => {
  const [teacher, setTeacher] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 8,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { pagination, list, loading, hasMore } = teacher;
  const { current, size } = pagination;
  const [draging, setDraging] = useState(false);
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const listRef = useRef();
  const history = useHistory();

  const onEndReached = () => {
    if (!loading && hasMore) {
      getTeacher(current);
    }
  };

  const getTeacher = async (page) => {
    let state = { loading: true, hasMore: true };
    if (page === 1) {
      state.list = [];
      setDataSource(dataSource.cloneWithRows([]));
    }
    setTeacher((famousSchool) => ({ ...famousSchool, ...state }));
    const response = await getUserTeachingInfoPage({
      size,
      current: page,
      realName: keyword,
      deptId,
      attrCode: subject ? 'sub_subject' : undefined,
      attrValue: subject || undefined,
    });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const dataList = current === 1 ? records : [...list, ...records];
      setTimeout(() => {
        setTeacher({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list: dataList,
          loading: false,
          hasMore,
        });
        setDataSource(dataSource.cloneWithRows(dataList));
        setDraging(false);
      }, 400);
    }
  };

  useEffect(() => {
    getTeacher(1);
  }, [keyword, subject]);

  const row = (rowData, sectionID, rowID) => {
    const { avatar, realName, attrList, id } = rowData;
    const subjectName = attrList[2] ? attrList[2].attributeValueName : '无';
    return (
      <Fragment key={rowID}>
        <LiveChannelItem
          coverUrl={avatar}
          title={realName}
          subject={subjectName}
          showIsLive={false}
          onClick={() => {
            history.push(`/apps/schoolTeacherInfo/${id}`);
          }}
        />
      </Fragment>
    );
  };

  return (
    <div className="school-teacher">
      <ListView
        ref={listRef}
        dataSource={dataSource}
        renderFooter={() => (
          <div style={{ textAlign: 'center' }}>
            {hasMore ? (
              loading ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <ActivityIndicator animating={true} text="加载中..." />
                </div>
              ) : (
                '加载完成'
              )
            ) : (
              '没有更多'
            )}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="active-list-wrap"
        pageSize={size}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            indicator={pullToRefreshText}
            onRefresh={() => {
              setDraging(true);
              getTeacher(1);
            }}
          />
        }
      />
    </div>
  );
};

const SchoolRes = ({ deptId, keyword, filter }) => {
  const [res, setRes] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 8,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { pagination, list, loading, hasMore } = res;
  const { current, size } = pagination;
  const [draging, setDraging] = useState(false);
  const [resType, setResType] = useState();
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const listRef = useRef();
  const resTypeCodeRef = useRef();

  const getRes = async (page) => {
    const { appId } = getApp() || {};
    let state = { loading: true, hasMore: true };
    if (page === 1) {
      state.list = [];
      setDataSource(dataSource.cloneWithRows([]));
    }
    setRes((famousSchool) => ({ ...famousSchool, ...state }));
    const response = await getResList({
      size,
      current: page,
      issueFlag: 1,
      sourceApp: appId,
      resType: resType,
      orgId: deptId,
      title: keyword,
      resAttributeDetailList: filter !== '[]' ? filter : undefined,
    });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const dataList = current === 1 ? records : [...list, ...records];
      setTimeout(() => {
        setRes({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list: dataList,
          loading: false,
          hasMore,
        });
        setDataSource(dataSource.cloneWithRows(dataList));
        setDraging(false);
      }, 400);
    }
  };

  const onEndReached = () => {
    if (!loading && hasMore) {
      getRes(current);
    }
  };

  useEffect(() => {
    if (resType) {
      getRes(1);
    }
  }, [keyword, resType, filter]);

  const row = (rowData, sectionID, rowID) => {
    const {
      resId,
      title,
      coverUrl,
      deptName,
      createrName,
      resAttributeDetailList,
      viewNum,
    } = rowData;
    const resAttr =
      resAttributeDetailList.length > 0
        ? resAttributeDetailList[0].attributeValueName +
          resAttributeDetailList[2].attributeValueName
        : null;
    return (
      <li className="school-res-item" key={rowID}>
        <ResItem
          id={resId}
          name={title}
          cover={coverUrl}
          dept={deptName}
          teacher={createrName}
          resAttr={resAttr}
          viewNum={viewNum}
          resType="2"
          showViewNum={resTypeCodeRef.current === 'VIDEO'}
        />
      </li>
    );
  };

  return (
    <div className="school-res">
      <Resource
        className="school-res-type"
        onChange={(type, typeCode) => {
          setResType(type);
          resTypeCodeRef.current = typeCode;
        }}
      />
      <div className="school-res-wrap">
        <ListView
          ref={listRef}
          dataSource={dataSource}
          renderFooter={() => (
            <div style={{ textAlign: 'center' }}>
              {hasMore ? (
                loading ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ActivityIndicator animating={true} text="加载中..." />
                  </div>
                ) : (
                  '加载完成'
                )
              ) : (
                '没有更多'
              )}
            </div>
          )}
          renderBodyComponent={() => <ListWrap />}
          renderRow={row}
          className="active-list-wrap"
          pageSize={size}
          scrollRenderAheadDistance={500}
          onEndReached={onEndReached}
          onEndReachedThreshold={10}
          pullToRefresh={
            <PullToRefresh
              refreshing={draging}
              indicator={pullToRefreshText}
              onRefresh={() => {
                setDraging(true);
                getRes(1);
              }}
            />
          }
        />
      </div>
    </div>
  );
};

const PrestigiousSchoolInfo = ({
  match: {
    params: { id },
  },
}) => {
  const [tab, setTab] = useState('liveRoom');
  const [keyword, setKeyword] = useState('');
  const [attrData, setAttrData] = useState([]);
  const [filter, setFilter] = useState();
  const [schoolInfo, setSchoolInfo] = useState({});
  const [subject, setSubject] = useState();
  const { deptName, cover } = schoolInfo;
  const { setFilters } = useContext(MyContext);
  const storeRef = useRef({ clearFilter: () => {} });

  const getSchoolInfo = async () => {
    const response = await detail({ schoolId: id });
    if (response.success) {
      const { deptName, spaceCoverUrl } = response.data;
      setSchoolInfo({ deptName, cover: spaceCoverUrl });
    }
  };

  const getAttrData = async () => {
    const { appCode } = getApp();
    const data = await getDefaultData(appCode);
    setAttrData({ ...data });
    if (storeRef.current.clearFilter) {
      storeRef.current.clearFilter();
    }
  };

  const handleAttrSelect = async ({ id, child, value }) => {
    if (child && value) {
      console.log(value);
      const response = await getAttrList({
        attributeTemplateDetailId: child,
        pAttrOptionValue: value,
      });
      if (!response.success) {
        return;
      }
      attrData[child].list = response.data.map((item) => ({
        name: item.text,
        value: item.value,
      }));
    }
    if (child && !value) {
      const clearChild = (item, key) => {
        const child = item[key].child;
        if (child) {
          item[child].list = [];
          clearChild(item, child);
        }
      };
      clearChild(attrData, id);
    }
    setAttrData({
      ...attrData,
    });
  };

  useEffect(() => {
    getSchoolInfo();
  }, []);

  useEffect(() => {
    setFilters(
      <Filter
        data={attrData}
        enableTime={false}
        onSelect={handleAttrSelect}
        key={attrData.length === 0 && new Date().getTime()}
        handleSearch={(item, clearFilter) => {
          const attrQuery = JSON.stringify(
            Object.keys(item)
              .filter((key) => Object.keys(attrData).indexOf(key) > -1)
              .map((id) => ({
                templateDetailId: id,
                attributeValue: item[id][0],
              })),
          );
          storeRef.current.clearFilter = clearFilter;
          setFilter(attrQuery);
        }}
      ></Filter>,
    );
  }, [attrData]);

  useEffect(() => {
    if (tab === 'teacher') {
      setFilters(
        <SubjectFilter
          onSearch={(value) => {
            setSubject(value);
          }}
        />,
      );
    } else {
      getAttrData();
    }
  }, [tab]);

  return (
    <div
      className={`prestigious-school-info${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}
    >
      <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => window.history.go(-1)}>
        <span>名校课堂</span>
      </NavBar>
      <div className="top-wrap">
        <SearchWrapper
          className="search-bar"
          onChange={(value) => {
            setKeyword(value);
          }}
        />
        <div className="school-info" style={{ backgroundImage: `url(${cover || bg_school})` }}>
          <div className="info-bar">
            <span>{deptName}</span>
            {/* <div className="info-bar-right">
              <span>正在直播(5)</span>
            </div> */}
          </div>
        </div>
      </div>
      <div className="bottom-wrap">
        <Tabs
          tabs={tabs}
          page={tab}
          prerenderingSiblingsNumber={0}
          swipeable={false}
          useOnPan={false}
          onChange={({ key }) => {
            if (key) {
              setTab(key);
            }
          }}
        >
          <Fragment key="liveRoom">
            <LiveRoom keyword={keyword} deptId={id} filter={filter} />
          </Fragment>
          <Fragment key="teacher">
            <SchooolTeacher keyword={keyword} deptId={id} subject={subject} />
          </Fragment>
          <Fragment key="res">
            <SchoolRes keyword={keyword} deptId={id} filter={filter} />
          </Fragment>
        </Tabs>
      </div>
    </div>
  );
};

export default (props) => {
  return (
    <DrawerWrapper>
      <PrestigiousSchoolInfo {...props} />
    </DrawerWrapper>
  );
};
